<template>
  <div class="app-size">
    <img
      v-if="currentBg"
      :src="require(`../assets/img/animations/fullscreengifs/${currentBg}`)"
      class="screen-root-image"
    />
    <img
      v-else
      @load="loadInitialData"
      src="../assets/img/login/background.jpg"
      class="screen-root-image"
      alt=""
    />
    <div
      v-if="isIntroduction == true"
      :id="isNotEnglish"
      style="opacity: 0.5;background:white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.videoContentForIntroduction')"
    ></div>
    <div
      v-if="isTutorialScreens == 1"
      :id="isNotEnglish"
      style="opacity: 0.5;background:#f6e7bc;color: #1a1a1a;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.tutorialFirstScreen_belt_center_talk')"
    ></div>
    <div
      v-if="isTutorialScreens == 2"
      :id="isNotEnglish"
      style="opacity: 0.5;background: #f6e7bc;color: #1a1a1a;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.tutorialSecondScreen_level_center_talk')"
    ></div>
    <div
      v-if="isTutorialScreens == 3"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.tutorialThirdScreen_black_belt_center')"
    ></div>
    <div
      v-if="isTutorialScreens == 4"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_3_8_A')"
    ></div>
    <div
      v-if="isTutorialScreens == 5"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_3_9')"
    ></div>
    <div
      v-if="isTutorialScreens == 6"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_belt_intro')"
    ></div>
    <div
      v-if="isTutorialScreens == 7"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_3_17')"
    ></div>
    <div
      v-if="isTutorialScreens == 8"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_3_18')"
    ></div>
    <div
      v-if="isTutorialScreens == 9"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_introForYellow_3_8_i')"
    ></div>
    <div
      v-if="isTutorialScreens == 10"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenYellow_3_27')"
    ></div>
    <div
      v-if="isTutorialScreens == 11"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenOrange_3_8_O')"
    ></div>
    <div
      v-if="isTutorialScreens == 12"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenOrange_3_8_e')"
    ></div>
    <div
      v-if="isTutorialScreens == 13"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenOrange_3_13')"
    ></div>
    <div
      v-if="isTutorialScreens == 15"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_green_3_10')"
    ></div>
    <div
      v-if="isTutorialScreens == 14"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_introForYellow_3_12')"
    ></div>
    <div
      v-if="isTutorialScreens == 16"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_blue_3_8_u')"
    ></div>
    <div
      v-if="isTutorialScreens == 17"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_blue_3_11')"
    ></div>
    <div
      v-if="isTutorialScreens == 18"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_blue_29')"
    ></div>
    <div
      v-if="isTutorialScreens == 19"
      :id="isNotEnglish"
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenYellow_3_8')"
    ></div>
    <img
      v-if="currentGif"
      :src="require(`../assets/img/animations/fullscreengifs/${currentGif}`)"
      alt=""
    />
    <img
      class="numbers-gif screen-root-image"
      v-if="currentSoundTag === 'dance_mid'"
      src="../assets/img/animations/fullscreengifs/numbers.gif"
      alt=""
    />
    <div class="skip-btn" @click="skipAnimation" v-show="showSkipBtn">
      <img
        src="../assets/img/animations/fullscreengifs/skip.png"
        class="skip-img"
      />
    </div>
    <audio
      @loadeddata="playSound"
      id="audioSrc"
      v-if="currentSoundTag"
      ref="currentSoundTag"
    >
      <source
        :src="
          require(`../assets/sound/fullscreensounds/${currentSoundTag}.mp3`)
        "
        type="audio/mpeg"
      />
    </audio>
  </div>
</template>

<script>
import animationsObj from '../config/gifsorder.json5';
// import { debuglog } from 'util';

export default {
  name: 'animation-generator',
  data() {
    return {
      animationsObj,
      animationData: null,
      currentGif: null,
      currentBg: null,
      currentSoundTag: null,
      currentAnimation: 0,
      isIntroduction: false,
      isTutorialScreens: 0,
      isTutorialVideoCompleted: 0,
      isNotEnglish:localStorage.getItem('selectedLang') && localStorage.getItem('selectedLang')!='en'?'arabictextalign':''
    };
  },
  computed: {
    showSkipBtn() {
      return (
        this.$route.params.animation.includes('dance') ||
        this.$route.params.animation.includes('ceremony') ||
        this.$route.params.animation.includes('tutorial')
      );
    }
    // dance() {
    //   if (
    //     this.$route.params.animation.includes('dance') ||
    //     this.$route.params.animation.includes('ceremony')
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // tutorial() {
    //   if (this.$route.params.animation.includes('tutorial')) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  },
  watch: {
    $route() {
      this.loadInitialData();
    }
  },
  methods: {
    playSound() {
      // console.log('play');
      this.$refs.currentSoundTag.play();
      // console.log(this.$refs.currentSoundTag.duration);
      this.$refs.currentSoundTag.onended = () => {
        // setTimeout(() => {
        this.nextAnimation();
        this.$refs.currentSoundTag.onended = () => {};
      };
      // duration is in seconds
      // }, this.$refs.currentSoundTag.duration * 1000);
    },
    loadInitialData() {
      if (
        !this.$route.params.animation ||
        !this.animationsObj[this.$route.params.animation]
      ) {
        alert('missing route params');
        this.$router.back();
      }
      this.currentAnimation = 0;
      this.animationData = this.animationsObj[this.$route.params.animation];
      this.currentGif = this.animationData.animationArr[
        this.currentAnimation
      ].filename;
      if (this.currentGif == 'jump.gif') {
        this.isIntroduction = true;
      }
      this.prepareAnimation(
        this.animationData.animationArr[this.currentAnimation]
      );
    },
    nextAnimation() {
      // console.log('nextAnimation');
      this.currentAnimation++;
      if (!this.animationData.animationArr[this.currentAnimation]) {
        // if (this.animationData.nextRoute.includes('ceremony')) {
        //   this.$router.push(this.animationData.nextRoute);
        //   location.reload();
        // }
        this.isTutorialVideoCompleted = 1;
        console.log('ended animations');
        this.$router.push(this.animationData.nextRoute);
        return;
      }
      this.prepareAnimation(
        this.animationData.animationArr[this.currentAnimation]
      );
      // }
    },
    prepareAnimation(animation) {
      this.currentGif = animation.filename;
      if (animation.background) {
        this.currentBg = animation.background;
      }
      if (!animation.duration) {
        this.currentSoundTag = animation.sound;
        if (this.$refs.currentSoundTag && this.$refs.currentSoundTag.load) {
          this.$refs.currentSoundTag.load();
        }
      } else {
        setTimeout(() => {
          this.nextAnimation();
        }, animation.duration);
      }
      if (this.currentSoundTag == 'belt_center_talk') {
        this.isTutorialScreens = 1;
      } else if (
        this.currentSoundTag == 'click_on_belt' ||
        this.currentSoundTag == 'level_center_talk'
      ) {
        this.isTutorialScreens = 2;
      } else if (
        this.currentSoundTag == 'black_belt_center' &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 3;
      } else if (
        (this.currentSoundTag == 'white_belt_intro' ||
          this.currentSoundTag == 'white_belt_A') &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 4;
      } else if (
        this.currentSoundTag == 'white_belt_illustration' &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 5; // 3.9
      } else if (
        this.currentSoundTag == 'Shva_talk' && this.currentGif !='Shva_TalkBeforeAction.gif' && 
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 0; // 3.8 A // not applicable for this
      } else if (
        this.currentSoundTag == 'Shva_illustration' &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 7; // 3.17
      } else if (
        this.currentSoundTag == 'ceremony_sound' &&
        this.currentGif != 'black_talk.gif'
      ) {
        this.isTutorialScreens = 8; // 3.18 with ceremony
      } else if (
        this.currentSoundTag == 'I_talk' ||
        this.currentSoundTag == 'I_action'
      ) {
        this.isTutorialScreens = 9; // for yellow first step
      } else if (
        (this.currentSoundTag == 'dance_start' ||
          this.currentSoundTag == 'dance_song') &&
        (this.currentGif == '01_white_talk.gif' ||
          this.currentGif == '02_yellow_talk.gif' ||
          this.currentGif == '03_orange_talk.gif' ||
          this.currentGif == '04_green_talk.gif' ||
          this.currentGif == '05_blue_talking.gif')
      ) {
        this.isTutorialScreens = 10; // for yellow dancing step
      } else if (
        this.currentSoundTag == 'O_talk' &&
        this.currentGif == 'O_TalkBeforeAction.gif'
      ) {
        this.isTutorialScreens = 11; // for Orange first step
      } else if (
        this.currentSoundTag == 'O_illustration' &&
        this.currentGif == 'O_illustration.gif'
      ) {
        this.isTutorialScreens = 13; // for Orange second step
      } else if (
        this.currentSoundTag == 'E_talk' &&
        this.currentGif == 'E_TalkBeforeAction.gif'
      ) {
        this.isTutorialScreens = 12; // for Green first step
      } else if (
        this.currentSoundTag == 'E_illustration' &&
        this.currentGif == 'E_illustration.gif'
      ) {
        this.isTutorialScreens = 15; // for Green second step
      } else if (
        this.currentSoundTag == 'I_illustration' &&
        this.currentGif == 'I_illustration.gif'
      ) {
        this.isTutorialScreens = 14; // for yellow second step
      } else if (
        this.currentSoundTag == 'U_talk' &&
        this.currentGif == 'U_TalkBeforeAction.gif'
      ) {
        this.isTutorialScreens = 16; // for blue first step
      } else if (
        this.currentSoundTag == 'U_illustration' &&
        this.currentGif == 'U_illustration.gif'
      ) {
        this.isTutorialScreens = 17; // for blue second step
      } else if (
        this.currentSoundTag == 'ceremony_sound' &&
        this.currentGif == 'black_talk.gif'
      ) {
        this.isTutorialScreens = 8; // 29 for blue with ceremony
      } else if (
        this.currentSoundTag == 'Shva_talk' && this.currentGif =='Shva_TalkBeforeAction.gif' &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 19; // animationGenYellow_3_8 for white
      } else if (
        this.currentSoundTag == 'game_final' && this.currentGif =='FinishGameTalk.gif' &&
        this.isTutorialVideoCompleted == 0
      ) {
        this.isTutorialScreens = 18; // animationGen_blue_29 //congrats msg for final steps
      } else {
        this.isTutorialScreens = 0;
      }
      console.log("pregiggg = "+ this.currentSoundTag + " flags = " + this.isTutorialVideoCompleted + " flags2 =" + this.currentGif);
    },
    skipAnimation() {
      this.$router.push(this.animationData.nextRoute);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';
.screen-root-image {
  z-index: -1;
}
.skip-btn {
  right: 0;
  bottom: 0;
  position: absolute;
  width: 14.6%;
  max-width: 100%;
}
.skip-img {
  position: relative;
  height: auto;
  display: block;
}

.numbers-gif {
  z-index: 0;
}
#arabictextalign {
  direction: rtl;
}
</style>
